export const fonts = {
  lato: 'Lato, Montserrat, sans-serif',
}

export const typography = {
  fontFamily: fonts.lato,

  h1: {
    fontSize: '36px',
    fontWeight: 700,
    lineHeight: '54px',
  },

  h2: {
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: '36px',
  },

  body1: {
    fontSize: 20,
    lineHeight: '24px',
  },

  body2: {
    fontSize: 16,
    lineHeight: '18px',
  },

  body3: {
    fontSize: 14,
    lineHeight: '18px',
  },

  body4: {
    fontSize: 12,
    lineHeight: '18px',
  },
}
